export const pageSizeSelector = state => state.api.workspaceSizes.pageSize;
export const workspaceSizesApiPageSelector = (state, page) => {
  return state.api.workspaceSizes.pages[page];
};
